import type React from 'react';
import styled from 'styled-components';

export interface Props {
  min: number;
  max: number;
  stepLength: number;
  factor: number;
  units: string;
  labelAlignment: string;
}

export const MeasurementBar: React.FC<Props> = ({ min, max, stepLength, units, factor, labelAlignment }) => {
  const sectionsCount = (max - min) / stepLength + 1;
  const scale = getScale(min, stepLength, sectionsCount, factor);

  return (
    <Measurements $alignContents={labelAlignment}>
      {scale.map((scaleValue, index) => {
        return (
          <div className="entryName" key={`${scaleValue}-${index}`}>
            {Math.round(scaleValue * 10) / 10} {units}
          </div>
        );
      })}
    </Measurements>
  );
};

const getScale = (start: number, step: number, marks: number, factor: number): Array<number> =>
  Array.from(Array(marks).keys(), (x) => (x * step + start) * factor);

const Measurements = styled.div<{ $alignContents: string }>`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  pointer-events: none;
  width: 2rem;
  & .entryName {
    text-align: ${(props): string => props.$alignContents};
    color: ${({ theme }): string => theme.font};
  }
`;
